
import { EntityService } from '@/services/entity.service'
import Vue from 'vue'
import New from './New.vue'
import Edit from './Edit.vue'
import moment from 'moment'
import * as msal from '@azure/msal-browser'
import mixin from './invoiceStatus.mixin'
import { UrlBase } from '@/config/base.config'
import { mapState } from 'vuex'
import { defaultFilter, getObjectValueByPath } from 'vuetify/lib/util/helpers'

const entityService = new EntityService()

export default Vue.extend({
  name: 'UsersList',
  components: {
    New,
    Edit
  },
  mixins: [mixin],
  data: () => ({
    entity: 'invoices',
    urlBase: UrlBase,
    search: '',
    listData: [],
    isLoading: false,
    isDownloadingPdfs: false,
    emailJob: null,
    selected: [],
    headers: [
      {
        text: 'Código',
        value: 'code'
      },
      {
        text: 'Estado',
        value: 'status'
      },
      {
        text: 'Nombre',
        value: 'name'
      },
      {
        text: 'Valor',
        value: 'amount'
      },
      {
        text: 'Proyecto',
        value: 'project'
      },
      {
        text: 'Archivos',
        value: 'files'
      },
      {
        text: 'Fecha Factura',
        value: 'createdAt'
      },
      {
        text: '',
        value: 'actions',
        align: 'right'
      }
    ],
    showModalNew: false,
    showModalEdit: false,
    showModalEmail: false,
    emailObj: {},
    editEntity: {},
    dateFrom: moment().subtract(1, 'months').format('YYYY-MM-DD'),
    dateTo: moment().format('YYYY-MM-DD'),
    projectId: null,
    status: null,
    menuDateFrom: false,
    menuDateTo: false,
    projects: []
  }),
  async created () {
    this.loadData().then()
    this.projects = await entityService.getList('projects')
  },
  methods: {
    async loadData () {
      this.isLoading = true
      const params = {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        projectId: this.projectId,
        status: this.status
      }
      this.listData = await entityService.getList(this.entity, params)
      this.isLoading = false
    },
    editEntityAction (entity: object) {
      this.editEntity = entity
      this.showModalEdit = true
    },
    async uploadFile (file: File) {
      if (!file) return
      if (!['ZIP', 'XML', 'PDF'].includes(file.name.split('.').pop().toUpperCase())) {
        alert('Archivo inválido')
        return
      }
      this.isLoading = true
      const response = await entityService.uploadFileRoot('upload', file)
      console.log(response)
      await this.loadData()
      this.isLoading = false
    },
    async download () {
      let csv = 'Código,Nit,Nombre,SubTotal,IVA,Total,Proyecto,Fecha\n'
      this.listData.forEach((row) => {
        csv += `${row.code},${row.nit},${row.name},${row.baseAmount || ''},${row.taxAmount || ''},${row.amount || ''},${row.project ? row.project.name : ''},${moment(row.createdAt).format('DD/MM/YYYY h:mm:ss a')}`
        csv += '\n'
      })
      const a = document.createElement('a')
      a.href = 'data:text/csv;charset=utf-8,\uFEFF' + encodeURIComponent(csv)
      a.target = '_blank'
      a.download = 'facturas.csv'
      a.click()
    },
    async downloadPdfs () {
      const invoiceIds = this.filteredItems.map((invoice) => invoice.id)
      if (!invoiceIds.length) return
      this.isDownloadingPdfs = true
      try {
        const response = await entityService.downloadFile(`${this.entity}/download-pdfs`, { invoiceIds })
        const a = document.createElement('a')
        a.href = URL.createObjectURL(response.data)
        a.download = `facturas-pdf_${this.dateFrom}_${this.dateTo}.zip`
        a.click()
        setTimeout(() => URL.revokeObjectURL(a.href), 1000)
        const missingPdfs = Number(response.headers['x-missing-pdfs'] || 0)
        if (missingPdfs > 0) {
          alert(`${missingPdfs} de ${invoiceIds.length} facturas no tienen PDF y no se incluyeron en el ZIP.`)
        }
      } catch (e) {
        alert(e.message)
      }
      this.isDownloadingPdfs = false
    },
    async connectEmail (limit) {
      const msalConfig = {
        auth: {
          clientId: 'a1771f68-48d4-4762-93b3-caf92f3eae53'
        }
      }
      const msalInstance = new msal.PublicClientApplication(msalConfig)
      await msalInstance.initialize()
      try {
        const loginRequest = {
          scopes: [
            'user.read',
            'mail.read',
            'mail.send'
          ]
        }
        const loginResponse = await msalInstance.loginPopup(loginRequest)
        console.log(loginResponse.accessToken)
        if (loginResponse.accessToken) {
          this.isLoading = true
          const params = {
            token: loginResponse.accessToken,
            limit: limit,
            background: true
          }
          const job = await entityService.getList('email', params)
          // Un back sin modo background responde al terminar, sin job que consultar
          if (job && job.id && job.status === 'running') {
            this.emailJob = job
            await this.waitEmailJob(job.id)
          } else if (job && job.status === 'error') {
            alert(job.error || 'Error leyendo los correos')
          }
          this.isLoading = false
          this.loadData().then()
        }
      } catch (err) {
        console.log(err)
        // Solo avisamos de errores del back, no de un popup de login cerrado
        if (this.isLoading) {
          this.isLoading = false
          alert(err.message)
        }
      }
    },
    async waitEmailJob (jobId: string) {
      const pollInterval = 4000
      const maxWait = 45 * 60 * 1000
      const startedAt = Date.now()
      let failures = 0
      while (Date.now() - startedAt < maxWait) {
        await new Promise((resolve) => setTimeout(resolve, pollInterval))
        try {
          this.emailJob = await entityService.getList(`email/status/${jobId}`)
          failures = 0
        } catch (e) {
          // Toleramos cortes puntuales de red antes de rendirnos
          if (++failures >= 3) {
            this.emailJob = null
            alert(`No se pudo consultar el progreso de la lectura de correos: ${e.message}`)
            return
          }
          continue
        }
        if (this.emailJob.status === 'done') {
          this.emailJob = null
          return
        }
        if (this.emailJob.status === 'error') {
          const error = this.emailJob.error
          this.emailJob = null
          alert(error || 'Error leyendo los correos')
          return
        }
      }
      this.emailJob = null
      alert('La lectura de correos sigue en curso en el servidor. Recarga la página más tarde para ver las facturas nuevas.')
    },
    openEmailDetail (item) {
      console.log(item.email.payload)
      this.emailObj = item.email.payload
      this.showModalEmail = true
    },
    async setInvoiceStatus (invoiceId, status) {
      this.isLoading = true
      const data = { status: status }
      await entityService.updateEntity(invoiceId, this.entity, data)
      this.isLoading = false
      this.loadData().then()
    },
    async sendM3Invoice (invoiceId: string) {
      this.isLoading = true
      try {
        const response = await entityService.getList(`/m3/send-invoice/${invoiceId}`)
        alert(response.message)
      } catch (e) {
        alert(e.message)
      }
      this.isLoading = false
      this.loadData().then()
    }
  },
  computed: {
    ...mapState(['user']),
    emailJobLabel () {
      const job = this.emailJob
      if (!job) return ''
      const stages = {
        reading: `Leyendo correos (${job.read || 0} de ${job.limit})`,
        attachments: `Descargando adjuntos de ${job.withAttachments || 0} correos`,
        saving: `Guardando facturas (${job.saved || 0} guardadas)`
      }
      return stages[job.stage] || 'Leyendo correos...'
    },
    // Mismas facturas que muestra la tabla: filtros del back + búsqueda de texto de v-data-table
    filteredItems () {
      const search = this.search ? this.search.trim() : ''
      if (!search) return this.listData
      return this.listData.filter((item) => this.headers.some(
        (header) => defaultFilter(getObjectValueByPath(item, header.value), search)
      ))
    },
    printParams () {
      if (this.selected.length <= 0) return
      const invoicesId = []
      for (const invoice of this.selected) {
        invoicesId.push(invoice.id)
      }
      return encodeURIComponent(JSON.stringify(invoicesId))
    }
  },
  watch: {
    showModalNew (value) {
      if (!value) this.loadData()
    },
    showModalEdit (value) {
      if (!value) this.loadData()
    }
  }
})
